import { useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Heading, Button, Alert, AlertIcon } from '@/components/v4';

import { IGNORED_MESSAGE } from './constants';

function useAPILoadingView({
    completionCounter,
    verificationResult,
    errorCounter,
    total: _total,
}) {
    const successful = completionCounter - errorCounter;
    const ignored =
        verificationResult?.passed?.data?.filter(
            (v) => v.verificationStatus === IGNORED_MESSAGE,
        ).length ?? 0;

    return {
        successful,
        errorCounter,
        ignored,
        isComplete: completionCounter >= _total,
        warning:
            'Do not close this window or navigate away. This may take a few minutes.',
        viewResultsText: 'View Results',
        header: 'Importing CSV...',
    };
}

export default function APILoadingView(props) {
    const { handleViewAPIResults } = props;
    const { darkMode } = useSelector((state) => state.settings);
    const {
        successful,
        errorCounter,
        ignored,
        isComplete,
        warning,
        viewResultsText,
        header,
    } = useAPILoadingView(props);

    return (
        <Box display="flex" justifyContent="start" width="100%">
            <Box
                width="100%"
                maxWidth="700px"
                display="flex"
                flexDirection="column"
                gap="0"
                fontFamily="Inter"
                boxShadow="base"
                p="8"
                bg={darkMode ? 'dark.tcap' : 'white'}
                rounded="md">
                <Heading size="lg" mb={4}>
                    {header}
                </Heading>

                {isComplete ? (
                    <Alert status="success" mb={4}>
                        <AlertIcon />
                        <Text size="sm">Completed</Text>
                    </Alert>
                ) : (
                    <Box mb={4}>
                        <Text
                            fontSize="sm"
                            color={darkMode ? 'gray.300' : 'gray.600'}>
                            {warning}
                        </Text>
                    </Box>
                )}

                <Box
                    p={4}
                    bg={darkMode ? 'gray.700' : 'gray.50'}
                    borderRadius="md"
                    border="1px solid"
                    borderColor={darkMode ? 'gray.600' : 'gray.200'}
                    mb={4}>
                    <Text color="green.500" fontSize="sm" mb={1}>
                        Successful : {successful}
                    </Text>
                    <Text color="red.500" fontSize="sm" mb={1}>
                        Failed : {errorCounter}
                    </Text>
                    <Text
                        color={darkMode ? 'gray.300' : 'gray.500'}
                        fontSize="sm">
                        No Change (Ignored) : {ignored}
                    </Text>
                </Box>

                {isComplete && (
                    <Box display="flex" justifyContent="right">
                        <Button
                            onClick={handleViewAPIResults}
                            rightIcon={<ArrowForwardIcon />}
                            size="sm">
                            {viewResultsText}
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
}
